import { useContext, useMemo } from 'react'

import moment from 'moment'
import { useSelector } from 'react-redux'

import { InternshipsManagerContext } from '../../../Context/InternshipsManager/InternshipsManagerProvider'
import { getDateTitle } from './utils/componentGetters'
import { DAY_AND_MONTH_FORMAT } from './utils/constants'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { SelectContext } from '../../../Providers/SelectProvider'
import { Ownership } from '../../../utils/entities/internship'
import LeftFloatingCheckbox from '../../antd/Checkbox/LeftFloatinCheckbox'
import { isInstitutionUser } from '../../../utils/roles'

const TH_STUDENT_TILE_STYLE = { width: '550px', zIndex: 100 }

const InternshipsTableHead = () => {
  const { dateColumns, internships } = useContext(InternshipsManagerContext)
  const { selected, setSelected } = useContext(SelectContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const DateTitle = getDateTitle(user.context)

  const renderTitleDate = () => {
    const currentDate = moment()
    currentDate.set('hour', 0)
    currentDate.set('minute', 0)
    currentDate.set('second', 0)

    return dateColumns.map((dates, index) => (
      <DateTitle
        key={dates.startDate.format(DAY_AND_MONTH_FORMAT)}
        startDate={dates.startDate}
        endDate={dates.endDate}
        index={index}
        isCurrent={dates.startDate <= currentDate && dates.endDate >= currentDate}
      />
    ))
  }

  const selectableInternships = useMemo(() => internships.filter(i => {
    return !i.individualInternshipRequest && i.ownership !== Ownership.INSTITUTION
  }), [internships])

  return (
    <thead>
      <tr>
        <th style={TH_STUDENT_TILE_STYLE}>
          {!isInstitutionUser(user) && (
            <LeftFloatingCheckbox
              checked={selected.length === selectableInternships.length && selected.length > 0}
              onChange={() => setSelected(selected.length === selectableInternships.length ? [] : [...selectableInternships])}
            />
          )}
          {t('Schools')} - {t('Students')}<br />
          {t('Sections')} - {t('Internship year')} - {t('Care units')}
        </th>
        {DateTitle !== null && renderTitleDate()}
      </tr>
    </thead>
  )
}

export default InternshipsTableHead
